import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useParams } from "react-router-dom";
import JigsawFacebookAdPage from "./JigsawFacebookAdPage";
import SlidingFacebookAdPage from "./SlidingFacebookAdPage";
import WordWheelFacebookAdPage from "./WordWheelFacebookAdPage";

/**
 * Router for `/admin/advertisement/app-screenshot-links/facebook-ad/:app`.
 */
export default function AppFacebookAdPage() {
    const { app } = useParams();

    if (app === "word-wheel") {
        return <WordWheelFacebookAdPage />;
    }
    if (app === "jigsaw") {
        return <JigsawFacebookAdPage />;
    }
    if (app === "sliding") {
        return <SlidingFacebookAdPage />;
    }

    return (
        <Box sx={{ p: 3 }}>
            <Typography color="error">
                Facebook Ads page is not available for &quot;{app}&quot;. Use word-wheel, jigsaw, or
                sliding.
            </Typography>
        </Box>
    );
}
